<div class="Mulifontstyle">
  <h2 id="main-content" attr.aria-label="{{ 'confirmation.title' | translate }}"> {{ "confirmation.title" | translate }}
  </h2>
  <p class="mt-4" attr.aria-label="{{ 'confirmation.claimSubmissionSuccess' | translate }}">
    {{ "confirmation.claimSubmissionSuccess" | translate }}</p>
  <p class="mt-4"
    attr.aria-label="{{ 'confirmation.youCan' | translate }} {{ 'confirmation.completedFormMsg' | translate }}">
    {{ "confirmation.youCan" | translate }} <a class="btn-wizard btn-bold" href="/printerpage" target="_blank"
      attr.aria-label="{{ 'confirmation.printSubmissionCopy' | translate }}">{{ "confirmation.printSubmissionCopy" | translate }}</a>
    {{ "confirmation.completedFormMsg" | translate }}
  </p>